import { tooltipRender } from '../../index';
import { Tooltip } from '@syncfusion/ej2-popups';
import { setStyleAttribute, createElement, Browser, isNullOrUndefined, extend } from '@syncfusion/ej2-base';
import { getTemplateFunction, MapLocation, getElement, checkShapeDataFields, Internalize } from '../utils/helper';
/**
 * Tooltip module class
 */
var MapsTooltip = /** @class */ (function () {
    function MapsTooltip(maps) {
        this.isTouch = false;
        this.touchDelay = 0;
        this.maps = maps;
        this.element = maps.element;
        this.addEventListener();
        this.ejTooltip = new Tooltip({
            opensOn: 'custom',
            position: 'TopCenter',
            beforeRender: this.onBeforeRender.bind(this),
            beforeOpen: this.tooltipCustomization.bind(this),
            openDelay: 0, closeDelay: 1,
        });
        this.ejTooltip.appendTo(this.element);
    }
    /**
     * To bind events for tooltip module
     */
    MapsTooltip.prototype.addEventListener = function () {
        if (this.maps.isDestroyed) {
            return;
        }
        this.maps.on(Browser.touchMoveEvent, this.mouseMove, this);
        this.maps.on(Browser.touchEndEvent, this.mouseMove, this);
    };
    /**
     * To unbind events for tooltip module
     */
    MapsTooltip.prototype.removeEventListener = function () {
        if (this.maps.isDestroyed) {
            return;
        }
        this.maps.off(Browser.touchMoveEvent, this.mouseMove);
        this.maps.off(Browser.touchEndEvent, this.mouseMove);
    };
    MapsTooltip.prototype.mouseMove = function (e) {
        if (this.isTouch && new Date().getTime() < this.touchDelay) {
            return;
        }
        this.setMouseXY(e);
        this.renderTooltip(e);
    };
    MapsTooltip.prototype.setMouseXY = function (e) {
        var pageX;
        var pageY;
        if (e.type.indexOf('touch') > -1) {
            this.isTouch = true;
            var touchArg = e;
            pageY = touchArg.changedTouches[0].clientY;
            pageX = touchArg.changedTouches[0].clientX;
        }
        else {
            this.isTouch = e.pointerType === 'touch' || e.pointerType === '2';
            pageX = e.clientX;
            pageY = e.clientY;
        }
        this.mouse = new MapLocation(pageX, pageY);
        this.touchDelay = new Date().getTime() + 100;
    };
    /**
     * Method to render the tooltip for maps.
     */
    MapsTooltip.prototype.renderTooltip = function (e) {
        if (this.previousId === e.target.id) {
            this.ejTooltip.refresh(this.appendTargetElement(this.mouse, 0));
        }
        else if (this.manipulateTarget(e.target)) {
            this.shapeColor = e.target.getAttribute('fill');
            if (document.querySelector('.e-tip-content') && !this.setTooltipContent(this.options) && !this.isTouch) {
                var args = {
                    type: null, cancel: false, element: this.customTooltip, event: e,
                    name: 'custom', target: this.tooltipEle
                };
                this.tooltipCustomization(args);
                return;
            }
            else {
                this.closeTooltip(1);
            }
            this.ejTooltip.open(this.appendTargetElement(this.mouse));
        }
        else {
            this.closeTooltip(1);
        }
    };
    MapsTooltip.prototype.getTargetElement = function (element) {
        var hoverElements = ['_ShapeIndex_', '_MarkerIndex_', '_BubbleIndex_'];
        if (!isNullOrUndefined(element.id) && element.id.length > 0 && element.id !== this.maps.element.id) {
            for (var i = 0; i < hoverElements.length; i++) {
                if (element.id.indexOf(hoverElements[i]) > -1) {
                    this.tooltipEle = element;
                    break;
                }
                else if (i === hoverElements.length - 1) {
                    this.getTargetElement(element.parentNode);
                }
            }
        }
        else if (element.id !== this.maps.element.id) {
            this.getTargetElement(element.parentNode);
        }
    };
    /* tslint:disable:no-string-literal */
    MapsTooltip.prototype.closeTooltip = function (delay, duration, effect) {
        if (duration === void 0) { duration = 0; }
        if (effect === void 0) { effect = 'None'; }
        this.ejTooltip.closeDelay = duration;
        this.ejTooltip.close({ delay: delay, duration: duration, effect: effect });
        this.previousId = null;
    };
    /* tslint:disable:no-string-literal */
    MapsTooltip.prototype.manipulateTarget = function (currentTarget) {
        this.tooltipEle = null;
        this.getTargetElement(currentTarget);
        if (isNullOrUndefined(this.tooltipEle)) {
            return false;
        }
        var target = this.tooltipEle.id;
        this.previousId = target;
        var index = parseFloat(target.split('_')[2]);
        var layer = this.maps.layersCollection[index];
        if (target.indexOf('_ShapeIndex_') > -1) {
            this.options = layer.tooltipSettings;
            var shape = parseInt(target.split('_')[4], 10);
            if (isNullOrUndefined(layer.shapeData['features'])) {
                return false;
            }
            var value = layer.shapeData['features'][shape]['properties'];
            index = checkShapeDataFields(layer.dataSource, value, layer.shapeDataPath, layer.shapePropertyPath);
            if (this.options.visible && ((!isNullOrUndefined(index) && !isNaN(index)) || (!isNullOrUndefined(value)))) {
                this.currentData = layer.dataSource[index] || value;
                return true;
            }
        }
        else if (target.indexOf('_MarkerIndex_') > -1) {
            var markerIndex = parseInt(target.split('_')[4], 10);
            var dataIndex = parseInt(target.split('_')[6], 10);
            var marker = layer.markerSettings[markerIndex];
            this.options = marker.tooltipSettings;
            if (!isNaN(markerIndex) && this.options.visible) {
                this.currentData = marker.dataSource[dataIndex];
                return true;
            }
        }
        else if (target.indexOf('_BubbleIndex_') > -1) {
            var bubbleIndex = parseInt(target.split('_')[4], 10);
            var dataIndex = parseInt(target.split('_')[6], 10);
            this.options = layer.bubbleSettings[bubbleIndex].tooltipSettings;
            if (!isNaN(bubbleIndex) && this.options.visible) {
                this.currentData = layer.bubbleSettings[bubbleIndex].dataSource[dataIndex];
                return true;
            }
        }
        return false;
    };
    /**
     * Method to append the target element for tooltip
     */
    MapsTooltip.prototype.appendTargetElement = function (location, padding) {
        if (padding === void 0) { padding = 10; }
        var element = getElement(this.element.id + '_MapsTooltip');
        var svgRect = getElement(this.element.id + '_svg').getBoundingClientRect();
        location.x -= svgRect.left;
        location.y -= (padding + svgRect.top);
        this.position = location;
        if (element) {
            element.style.left = location.x + 'px';
            element.style.top = location.y + 'px';
        }
        else {
            element = createElement('div', {
                id: this.element.id + '_MapsTooltip',
                styles: 'position: absolute;left:' + location.x + 'px;top:' + location.y +
                    'px;width:2px;height:2px;background:transparent;pointer-events:none;'
            });
            getElement(this.element.id + '_Secondary_Element').appendChild(element);
        }
        return element;
    };
    MapsTooltip.prototype.formatter = function (format, data) {
        if (isNullOrUndefined(format)) {
            return null;
        }
        var keys = Object.keys(data);
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            format = format.split('${' + key + '}').join(data[key]);
        }
        return format;
    };
    /**
     * Method to perform the tooltip for maps.
     */
    MapsTooltip.prototype.onBeforeRender = function (args) {
        args.cancel = this.setTooltipContent(this.options);
        this.ejTooltip.dataBind();
    };
    /**
     * To get content for the current toolitp
     */
    MapsTooltip.prototype.setTooltipContent = function (options) {
        if (options === void 0) { options = this.options; }
        var localData = extend({}, this.currentData, null, true);
        if (this.maps.format && !isNaN(parseFloat(localData[options.valuePath]))) {
            localData[options.valuePath] = Internalize(this.maps, parseFloat(localData[options.valuePath]));
        }
        var content = this.formatter(options.format, localData) || localData[options.valuePath];
        content = options.template ? this.joinElements(getTemplateFunction(options.template)(localData)) : content;
        this.textStyle = extend(options.textStyle, options.textStyle, null, true);
        this.textStyle.color = this.textStyle.color || this.shapeColor;
        var argsData = {
            cancel: false, name: tooltipRender,
            content: content,
            border: options.border,
            textStyle: this.textStyle,
            fill: options.fill,
        };
        this.maps.trigger(tooltipRender, argsData);
        this.border = argsData.border;
        this.shapeColor = argsData.fill;
        this.ejTooltip.content = argsData.content;
        return argsData.cancel || (isNullOrUndefined(argsData.content) || argsData.content === '');
    };
    MapsTooltip.prototype.joinElements = function (elements) {
        var elementString = '';
        [].forEach.call(elements, function (ele) {
            elementString += ele.outerHTML;
        });
        return elementString;
    };
    /**
     * Method to customize the tooltip elements for maps.
     */
    MapsTooltip.prototype.tooltipCustomization = function (args, options) {
        if (options === void 0) { options = this.options; }
        this.customTooltip = args.element;
        if (options.template) {
            setStyleAttribute(args.element, {
                'backgroundColor': 'transparent', 'borderColor': 'transparent',
                'borderWidth': '1px', 'pointer-events': 'none'
            });
            setStyleAttribute(args.element.querySelector('.e-arrow-tip'), {
                'width': '0px', 'height': '0px'
            });
            if (this.isTouch) {
                this.closeTooltip(1, 1500, 'FadeOut');
            }
            return null;
        }
        var font = this.textStyle;
        var borderColor = this.border.color;
        var border = this.border.width;
        var pointerSize = 8;
        var arrowWidth = (pointerSize - border) + 'px';
        var outerWidth;
        var innerWidth;
        var arrowEle = args.element.querySelector('.e-arrow-tip');
        setStyleAttribute(args.element, {
            'backgroundColor': this.shapeColor, 'borderColor': borderColor || '#212121',
            'borderWidth': border + 'px', 'pointer-events': 'none', 'borderRadius': '5px', 'padding-left': '5px',
            'padding-right': '5px', 'padding-top': '3px', 'padding-bottom': '3px'
        });
        setStyleAttribute(args.element.querySelector('.e-tip-content'), {
            'color': font.color, 'fontFamily': font.fontFamily, 'fontSize': font.size,
            'fontWeight': font.fontWeight, 'fontStyle': font.fontStyle, 'padding-left': '5px',
            'padding-right': '5px', 'padding-top': '3px', 'padding-bottom': '3px'
        });
        setStyleAttribute(args.element.querySelector('.e-arrow-tip'), {
            'width': 2 * (pointerSize + border) + 'px', 'height': pointerSize + border + 'px'
        });
        if (arrowEle.classList.contains('e-tip-top')) {
            outerWidth = pointerSize + 'px';
            setStyleAttribute(args.element.querySelector('.e-arrow-tip-outer'), {
                'borderRightColor': 'transparent', 'borderLeftColor': 'transparent', 'borderBottomColor': borderColor,
                'borderLeftWidth': outerWidth, 'borderRightWidth': outerWidth, 'borderBottomWidth': outerWidth,
            });
            innerWidth = (pointerSize - border) + 'px';
            setStyleAttribute(args.element.querySelector('.e-arrow-tip-inner'), {
                color: this.shapeColor, top: '0px'
            });
        }
        else if (arrowEle.classList.contains('e-tip-bottom')) {
            outerWidth = pointerSize + 'px';
            setStyleAttribute(args.element.querySelector('.e-arrow-tip-outer'), {
                'borderRightColor': 'transparent', 'borderLeftColor': 'transparent', 'borderTopColor': borderColor,
                'borderLeftWidth': outerWidth, 'borderRightWidth': outerWidth, 'borderTopWidth': outerWidth,
            });
            innerWidth = (pointerSize - border) + 'px';
            setStyleAttribute(args.element.querySelector('.e-arrow-tip-inner'), {
                color: this.shapeColor
            });
        }
        setStyleAttribute(args.element, {
            'display': 'block', 'transitionProperty': 'left,top',
            'transitionDuration': '1ms'
        });
        if (this.isTouch) {
            this.closeTooltip(1000, 1500, 'FadeOut');
        }
    };
    /**
     * Get module name.
     */
    MapsTooltip.prototype.getModuleName = function () {
        return 'MapsTooltip';
    };
    /**
     * To destroy the tooltip.
     * @return {void}
     * @private
     */
    MapsTooltip.prototype.destroy = function (maps) {
        this.removeEventListener();
        this.ejTooltip.destroy();
    };
    return MapsTooltip;
}());
export { MapsTooltip };
